module.exports = __webpack_public_path__ + "img/front-iluminado-dark.2eb2f292.png";